var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicies({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    width: "24px",
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.9, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48206e",
    d: "M30,30l-.43-.14C17.42,25.91,17.89,15.21,18,14V5.06L30,0,42,5.06v9c.08,1.17.54,11.91-11.59,15.82ZM20.78,6.92v7.31c-.07,1-.44,9.43,9.23,12.83,10.17-3.54,9.27-12.43,9.23-12.81V6.92L30,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9586bc",
    d: "M37.55,14.37V8.6L30,5.43,22.45,8.6v5.77S21.71,21.92,30,24.62C38.38,21.92,37.55,14.37,37.55,14.37Zm-3.64-1.3-1.67,1.67c0,.1-.1.1-.1.19l.38,2.33c0,.09-.1.19-.19.28h-.09l-2.15-1.12h-.18l-2.15,1c-.09.09-.18,0-.28-.1v-.09l.38-2.33c0-.09,0-.09-.1-.19l-1.58-1.67a.18.18,0,0,1,0-.28l.09-.09,2.33-.38c.1,0,.1-.09.19-.09l1.12-2.05c0-.09.09-.19.28,0v0l1.11,2.05c0,.09.1.09.19.09l2.33.38c.09,0,.19.09.19.27A.1.1,0,0,1,33.91,13.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.5f89275098eceb3e4783db6f35df9cdf.svg";
export { ForwardRef as ReactComponent };